export default {
  list: {
    name: "task list api",
    version: 6,
    url: "task@tasks",
    method: "GET",
  },
  create: {
    name: "task create api",
    version: 6,
    url: "task@tasks",
    method: "POST",
  },
  update: {
    name: "task update api",
    version: 6,
    url: "task@tasks/%{id}",
    method: "PUT",
  },
  delete: {
    name: "task delete api",
    version: 6,
    url: "task@tasks/%{id}",
    method: "DELETE",
  },
  show: {
    name: "task show api",
    version: 6,
    url: "task@tasks/%{id}",
    method: "GET",
  },
};
